module.exports = __webpack_public_path__ + "img/GenteBoaConectada.aab55f1d.svg";